<!-- 上传图片按钮 -->
<template>
    <div style="height: 100%; width: 100%">
        <el-button size="small" class="btn-primary" v-if="viewName == 'EntpEditSale'"
            style="background-color: #409EFF;border-color: #409EFF;color:#fff" @click="showdialog">{{ text ? text : '选择图片'
            }}</el-button>
        <el-dialog :close-on-click-modal="false" title="图片上传" :visible.sync="dialogVisible" :append-to-body="true"
            custom-class="base-dialog" width="1000px" @close="onClose">
            <div class="dialog-content" style="padding: 0" v-if="dialogVisible" v-loading="loading">
                <el-container style="min-height: 600px">
                    <el-header style="height: auto; text-align: center">
                        <div id="uploadArea" class="el-upload el-upload--text" ref="uploadArea"
                            style="padding-top: 10px">
                            <div class="el-upload-dragger">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">
                                    <p>将文件拖到此处，</p>
                                    <p>或将图片按Ctrl+V 粘贴至此处，</p>
                                    <p>
                                        或
                                        <em @click="uploadBtnClick">点击选择</em>
                                        <input type="file" ref="uploadBtn" :multiple="multiple" accept="image/*"
                                            @change="uploadBtnChange($event)" style="opacity: 0; display: none" />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-header>
                    <el-main style="height: 450px">
                        <div class="img-wall">
                            <el-card class="box-card" v-for="(item, index) in previewImgList" :key="index"
                                :body-style="{ height: '100%', position: 'relative' }">
                                <i class="el-icon-close closebtn" @click="removePreviewImg(item, index)"></i>
                                <img :src="item.indexOf('data:image') == -1 ? downloadUrl + item : item" />
                            </el-card>
                        </div>
                    </el-main>
                    <el-footer style="text-align: right">
                        <el-button type="info" @click="onClose">取消</el-button>
                        <el-button type="primary" @click="returnFileList" v-if="viewName == 'EntpEditSale'">确定</el-button>
                        <el-button type="primary" @click="submitImg" v-else>提交</el-button>
                    </el-footer>
                </el-container>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="previewList" :z-index="99999"
            :initial-index="initialIndex" />
    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    name: 'uploadBtn',
    components: { ElImageViewer },
    props: {
        text: {
            type: String
        },
        type: {
            type: String
        },
        limit: {
            type: Number,
            default: 999
        },
        multiple: {
            type: Boolean,
            default: false
        },
        viewName:{
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        initfileList: { type: Array, default: () => [] }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            loading: false,
            havedList: [], // 原来已有的图片
            fileList: [],
            url: '/api/UploadFile/UploadMultiple',
            uploadData: {
                key: this.type,
                isPrivate: false
            },
            token: userMsg.Token,
            uploadHeaders: {},
            dialogVisible: false,
            previewImgList: [], //预览图片列表
            uploadQueue: [], //待上传图片队列
            showViewer: false, // 是否显示预览图片
            initialIndex: 0, // 初始化展示哪张图片
            previewList: [], // 上传图片预览列表
            orderId: '',
            mdList:[]
        };
    },
    watch: {
    },
    mounted() {
    },
    beforeDestroy() {
        //注销粘贴事件
        document.removeEventListener('paste', this.handlePaste, false);
    },
    methods: {
        showdialog(res, id) {
            this.dialogVisible = true;
            this.$nextTick(() => {
                let uploadArea = document.querySelector('#uploadArea');
                uploadArea.addEventListener('dragenter', this.onDrag, false);
                uploadArea.addEventListener('dragover', this.onDrag, false);
                uploadArea.addEventListener('drop', this.onDrop, false);
                document.addEventListener('paste', this.handlePaste, false);
            });
            if (id) {
                this.previewImgList = res;
                this.havedList = res;
                this.orderId = id;
            }
        },
        //关闭弹窗
        onClose() {
            //注销粘贴事件
            document.removeEventListener('paste', this.handlePaste, false);
            this.previewImgList = [];
            this.uploadQueue = [];
            this.dialogVisible = false;
        },
        onDrag: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },
        //触发选择图片的按钮
        uploadBtnClick() {
            this.$refs.uploadBtn.click();
        },
        //点击上传
        uploadBtnChange(e) {
            let that = this;
            let imgfile = this.$refs.uploadBtn;

            if (!that.multiple && that.uploadQueue.length >= 1) {
                this.$message.warning('最多只能上传1张图片');
                return false;
            } else if ((that.limit <= that.uploadQueue.length) || (that.limit <= imgfile.files.length)) {
                this.$message.warning('最多只能上传' + that.limit + '张图片');
                return false;
            }

            for (let i = 0; i < imgfile.files.length; i++) {
                if (!that.uploadCheck(imgfile.files[i], that)) {
                    continue;
                }
                let reader = new FileReader();
                reader.readAsDataURL(imgfile.files[i]);
                reader.onload = function () {
                    that.previewImgList.push(this.result);

                    let img = {
                        url: this.result,
                        data: imgfile.files[i]
                    };
                    that.uploadQueue.push(img);
                };

                if (!that.multiple) {
                    return;
                }
            }
        },
        //拖拽上传
        onDrop: function (e) {
            e.stopPropagation();
            e.preventDefault();
            let that = this;
            let dt = e.dataTransfer;
            // document.querySelector(".imgName").innerHTML = imgfile.files[0].name;

            if (!that.multiple && that.uploadQueue.length >= 1) {
                this.$message.warning('最多只能上传1张图片');
                return false;
            } else if ((that.limit <= that.uploadQueue.length) || (that.limit <= dt.files.length)) {
                this.$message.warning('最多只能上传' + that.limit + '张图片');
                return false;
            }

            for (let i = 0; i < dt.files.length; i++) {
                if (!that.uploadCheck(dt.files[i], that)) {
                    continue;
                }
                let reader = new FileReader();
                reader.readAsDataURL(dt.files[i]);

                let img = {
                    url: this.result,
                    data: dt.files[i]
                };
                that.uploadQueue.push(img);
                reader.onload = function () {
                    that.previewImgList.push(this.result);
                };

                if (!that.multiple) {
                    return;
                }
            }
        },
        // 监听粘贴操作
        handlePaste(event) {
            if (!this.dialogVisible) return false;

            let that = this;
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;

            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持粘贴模式');
                return;
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    file = items[i].getAsFile();
                    break;
                }
            }
            if (!file) {
                return;
            }

            if (!that.multiple && that.uploadQueue.length >= 1) {
                this.$message.warning('最多只能上传1张图片');
                return false;
            } else if ((that.limit <= that.uploadQueue.length) || that.limit <= items.length) {
                this.$message.warning('最多只能上传' + that.limit + '张图片');
                return false;
            }
            if (!that.uploadCheck(file, that)) {
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = event => {
                that.previewImgList.push(event.target.result);

                let img = {
                    url: event.target.result,
                    data: file
                };
                that.uploadQueue.push(img);
            };
        },
        //删除预览文件
        removePreviewImg(file, index) {
            this.previewImgList.splice(index, 1);
            this.uploadQueue.splice(index, 1);
        },
        returnFileList() {
            let res = {
                viewList: this.previewImgList,
                queueList: this.uploadQueue
            }
            this.$emit('uploadSuccess', res);
            this.onClose();
        },
        submitImg() {
            let that = this;
            if (that.uploadQueue.length == 0) {
                that.submitEditImg();
            } else {
                that.startUploading()
                    .then(() => {
                        that.submitEditImg();
                    })
                    .catch((err) => {
                        that.loading = false;
                        that.$util.errorMsg('文件上传失败，请重试');
                    });
            }
        },
        submitEditImg() {
            let that = this;
            that.loading = true;

            let arr = that.havedList.filter(f => f.indexOf('/LogisMD/') !== -1);
            that.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/EditSaleOrderMDImgs',
                    data: { EntpCusOId: that.orderId, MDPictureList: arr },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.$util.successMsg('提交成功');
                        that.onClose();
                    } else {
                        that.$util.errorMsg(res.errmsg);
                    }
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        //开始上传
        startUploading() {
            let that = this;
            that.loading = true;
            return new Promise((resolve, reject) => {
                let fd = new window.FormData();

                for (let index = 0; index < that.uploadQueue.length; index++) {
                    fd.append('files', that.uploadQueue[index].data);
                }
                fd.append('key', that.uploadData.key);
                fd.append('isPrivate', that.uploadData.isPrivate);
                let xhr = new XMLHttpRequest();
                xhr.open('POST', that.url, true);

                xhr.setRequestHeader('access-key', that.token);

                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let result = JSON.parse(xhr.responseText);
                        if (result.errcode == 500) {
                            that.loading = false;
                        } else {
                            for (let i = 0; i < result.length; i++) {
                                let item = JSON.parse(result[i]);
                                if (item.errcode == 0 && item && item.fileUrl) {
                                    that.havedList.push(item.fileUrl);
                                }
                            }
                            that.loading = false;
                            resolve();
                        }
                    } else {
                        that.loading = false;
                    }
                };

                xhr.onerror = () => {
                    this.$util.errorMsg('上传失败');
                    that.loading = false;
                };
                xhr.send(fd);
            });
        },
        uploadSuccess(res) {
            this.$emit('uploadSuccess', res.fileUrl);
        },
        uploadErr() {
            this.$util.errorMsg('上传失败');
        },
        beforeUpload(file) {
            return this.$util.uploadCheck(file);
        },
        clearData() {
            this.fileList = [];
            this.havedList = [];
        },
        handleRemove(file, index) {
            this.$emit('handleRemove', file);
            this.havedList.splice(index, 1);
        },
        ///因为需要判断图片大小是否符合但是因为img.onload需要等图片加载完成才能获取长宽
        ///检查方法没等里面onload走完就返回了空值，直接在里面完成赋值这些吧，仅限电商
        uploadCheck(file, that) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';

            //改成10M
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt20M) {
                this.$util.warningMsg('上传图片大小不能超过 20MB!');
            }

            return (isJPG || isBMP || isGIF || isPNG) && isLt20M;
        },
        // 关闭查看器
        closeViewer() {
            this.showViewer = false;
        },
        // 打开上传图片预览
        onPreview(row, index) {
            this.initialIndex = index;
            this.previewList = row.map(item => this.downloadUrl + item);
            this.showViewer = true;
        },
    }
};
</script>
<style lang="less" scoped>
.img-wall {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 50px;
}

.box-card {
    height: 150px;
    width: 150px;

    img {
        width: 100%;
        height: 100%;
    }

    .closebtn {
        position: absolute;
        right: 0px;
        background-color: #909399;
        border-radius: 50%;
        padding: 1px;
        cursor: pointer;
    }
}

.el-upload-list__item {
    z-index: 99;
}
</style>
